<div class="crm-page">
  <app-header
    [title]="'TITLES.ORGANIZATIONS' | translate"
    [subtitle]="'COMPONENTS.ORGANIZATIONS.SUBTITLE' | translate"
  >
    <div header-actions class="crm-page__header-actions">
      <div class="hidden lg:block">
        <app-navbar-profile-info></app-navbar-profile-info>
      </div>
    </div>
  </app-header>

  <div class="crm-page__content px-4 md:px-8 py-6 md:py-8">
    @if (isLoading) {
      <div class="crm-page__overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ "MESSAGES.LOADING" | translate }}</span>
        </div>
      </div>
    }

    <div class="crm-page__toolbar">
      <div class="crm-list-search form-search">
        <div class="input-search">
          <input
            type="text"
            [value]="searchTerm"
            [placeholder]="'COMPONENTS.ORGANIZATIONS.SEARCH_PLACEHOLDER' | translate"
            [attr.aria-label]="'COMPONENTS.ORGANIZATIONS.SEARCH_PLACEHOLDER' | translate"
            (input)="onSearchChange($any($event.target).value)"
          />
          <span class="search-icon" aria-hidden="true">
            <img src="assets/img/search.svg" alt="" />
          </span>
        </div>
      </div>

      @if (canCreateOrganization$ | async) {
        <div class="crm-page__toolbar-actions">
          <button
            type="button"
            class="crm-page__action-button crm-import-button"
            (click)="openImport()"
          >
            <span class="crm-import-button-icon" aria-hidden="true">
              <svg focusable="false" viewBox="0 0 16 16">
                <path
                  d="M8 1.5a.5.5 0 0 1 .5.5v6.293l2.146-2.147a.5.5 0 1 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 8.293V2a.5.5 0 0 1 .5-.5Zm-5 10A1.5 1.5 0 0 0 4.5 13h7A1.5 1.5 0 0 0 13 11.5v-.5a.5.5 0 0 1 1 0v.5A2.5 2.5 0 0 1 11.5 14h-7A2.5 2.5 0 0 1 2 11.5v-.5a.5.5 0 0 1 1 0v.5Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <span class="crm-import-button-label">
              {{ "BUTTONS.IMPORT" | translate }}
            </span>
          </button>
          <button
            id="add-organization-container"
            type="button"
            class="crm-page__action-button crm-page__action-button--primary"
            (click)="openCreateOrganizationModal()"
          >
            + {{ "BUTTONS.ADD_ORGANIZATION" | translate }}
          </button>
        </div>
      }
    </div>

    @if (organizations$ | async; as organizations) {
      @if (organizations.items.length === 0) {
        <app-card-shell class="crm-page__empty-card" padding="none">
          <div class="crm-page__empty-state">
            <app-empty-content
              [showImage]="true"
              [message]="
                'MESSAGES.EMPTY_LIST'
                  | translate: { param: emptyOrganizationListParam[currentLang] }
              "
              [tooltip]="'TOOLTIPS.EMPTY_ORGANIZATION_LIST' | translate"
              [textPositionClass]="'text-center'"
            />
          </div>
        </app-card-shell>
      } @else {
        <app-card-shell class="crm-page__list-card" padding="none">
          <div class="crm-table__desktop">
            <div class="crm-table__scroller">
              <table class="crm-table__table">
                <thead>
                  <tr class="crm-table__header-row">
                    <th class="crm-table__header-cell crm-table__header-cell--type"></th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="title"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.TITLE" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="address"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.ADDRESS" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="city"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.CITY" | translate }} / {{ "TABLE_HEADERS.COUNTRY" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="contactsCount"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.CONTACTS_COUNT" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="email"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.EMAIL" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="phoneNumber"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.PHONE_NUMBER" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="responsibleUserName"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.RESPONSIBLE" | translate }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  @for (organization of organizations.items; track organization.id) {
                    <tr class="crm-table__row">
                      <td class="crm-table__cell crm-table__cell--type">
                        <ng-container
                          [ngTemplateOutlet]="entityTypeIcon"
                          [ngTemplateOutletContext]="{ organization: organization }"
                        ></ng-container>
                      </td>
                      <td class="crm-table__cell crm-table__cell--title">
                        <a [routerLink]="organization.id" [title]="organization.title">
                          {{ organization.title }}
                        </a>
                      </td>
                      <td class="crm-table__cell" [title]="organization.address">
                        {{ organization.address || "-" }}
                      </td>
                      <td class="crm-table__cell" [title]="organization.location">
                        {{ organization.location || "-" }}
                      </td>
                      <td class="crm-table__cell" [title]="organization.contactsCount.toString()">
                        {{ organization.contactsCount }}
                      </td>
                      <td class="crm-table__cell" [title]="organization.email">
                        {{ organization.email || "-" }}
                      </td>
                      <td class="crm-table__cell" [title]="organization.phoneNumber">
                        {{ organization.phoneNumber || "-" }}
                      </td>
                      <td class="crm-table__cell">
                        @if (organization.hasResponsibleUser) {
                          <button
                            type="button"
                            class="crm-table__profile-button"
                            [title]="organization.responsibleUserName"
                            (click)="viewProfile(organization.responsibleUserId)"
                          >
                            {{ organization.responsibleUserName }}
                          </button>
                        } @else {
                          <span class="crm-table__muted">-</span>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>

          <div class="crm-page__footer organizations-page__footer--desktop">
            <app-paginator
              class="crm-page__paginator"
              [totalItems]="organizations.totalCount"
              [page]="organizations.page"
              [pageSize]="organizations.pageSize"
              [showSummary]="true"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onChangePageSize($event)"
            />
          </div>
        </app-card-shell>

        <div class="crm-table__mobile-section">
          <div class="crm-table__mobile-list">
            @for (organization of organizations.items; track organization.id) {
              <article class="crm-mobile-card">
                <div class="crm-mobile-card__header">
                  <div class="crm-mobile-card__title-wrap">
                    <ng-container
                      [ngTemplateOutlet]="entityTypeIcon"
                      [ngTemplateOutletContext]="{ organization: organization }"
                    ></ng-container>

                    <div class="crm-mobile-card__title-block">
                      <a
                        class="crm-mobile-card__title"
                        [routerLink]="organization.id"
                        [title]="organization.title"
                      >
                        {{ organization.title }}
                      </a>
                    </div>
                  </div>
                </div>

                <div class="crm-mobile-card__grid">
                  <div class="crm-mobile-card__field crm-mobile-card__field--count">
                    <p class="crm-mobile-card__label">
                      {{ "TABLE_HEADERS.CONTACTS_COUNT" | translate }}
                    </p>
                    <p class="crm-mobile-card__value crm-mobile-card__value--count">
                      {{ organization.contactsCount }}
                    </p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">
                      {{ "TABLE_HEADERS.ADDRESS" | translate }}
                    </p>
                    <p class="crm-mobile-card__value">
                      {{ organization.address || "-" }}
                    </p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">
                      {{ "TABLE_HEADERS.CITY" | translate }} / {{ "TABLE_HEADERS.COUNTRY" | translate }}
                    </p>
                    <p class="crm-mobile-card__value">
                      {{ organization.location || "-" }}
                    </p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">
                      {{ "TABLE_HEADERS.EMAIL" | translate }}
                    </p>
                    <p class="crm-mobile-card__value">
                      {{ organization.email || "-" }}
                    </p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">
                      {{ "TABLE_HEADERS.PHONE_NUMBER" | translate }}
                    </p>
                    <p class="crm-mobile-card__value">
                      {{ organization.phoneNumber || "-" }}
                    </p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">
                      {{ "TABLE_HEADERS.RESPONSIBLE" | translate }}
                    </p>
                    @if (organization.hasResponsibleUser) {
                      <button
                        type="button"
                        class="crm-table__profile-button crm-table__profile-button--mobile"
                        [title]="organization.responsibleUserName"
                        (click)="viewProfile(organization.responsibleUserId)"
                      >
                        {{ organization.responsibleUserName }}
                      </button>
                    } @else {
                      <p class="crm-mobile-card__value crm-table__muted">-</p>
                    }
                  </div>
                </div>
              </article>
            }
          </div>

          <div class="crm-page__footer organizations-page__footer--mobile">
            <app-paginator
              class="crm-page__paginator"
              [totalItems]="organizations.totalCount"
              [page]="organizations.page"
              [pageSize]="organizations.pageSize"
              [showSummary]="true"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onChangePageSize($event)"
            />
          </div>
        </div>
      }
    }

    <app-reusable-modal
      [isOpen]="isCreateOrganizationModalOpen"
      [panelClass]="'max-w-4xl'"
      [contentScoped]="true"
      [title]="'TITLES.ADD_ORGANIZATION' | translate"
      [subtitle]="'COMPONENTS.ORGANIZATIONS.CREATE_MODAL_SUBTITLE' | translate"
      (closed)="closeCreateOrganizationModal()"
    >
      <app-create-organization
        [companyId]="companyId"
        (cancelled)="closeCreateOrganizationModal()"
        (created)="onCreateOrganization()"
      />
    </app-reusable-modal>
  </div>
</div>

<ng-template #entityTypeIcon let-organization="organization">
  <span
    class="crm-table__type-badge"
    [class.crm-table__type-badge--regular]="organization.entityType === 'regular'"
    [class.crm-table__type-badge--customer]="organization.entityType === 'customer'"
    [class.crm-table__type-badge--vendor]="organization.entityType === 'vendor'"
    [title]="organization.entityTypeTitle"
  >
    @switch (organization.entityType) {
      @case ('customer') {
        <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16">
          <path
            d="M0 1.5A.5.5 0 0 1 .5 1h1a.5.5 0 0 1 .49.402L2.89 6h10.72a.5.5 0 0 1 .48.637l-1.2 4A.5.5 0 0 1 12.41 11H4.1a.5.5 0 0 1-.49-.402L1.61 2H.5A.5.5 0 0 1 0 1.5zM5 12.5A1.5 1.5 0 1 0 5 15.5 1.5 1.5 0 0 0 5 12.5zm6 0A1.5 1.5 0 1 0 11 15.5 1.5 1.5 0 0 0 11 12.5z"
          />
        </svg>
      }
      @case ('vendor') {
        <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16">
          <path
            d="M6.5 0a.5.5 0 0 0-.5.5V2H3a2 2 0 0 0-2 2v2h14V4a2 2 0 0 0-2-2h-3V.5a.5.5 0 0 0-.5-.5h-3zM7 2V1h2v1H7zM1 7v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7H1zm3.5 2.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"
          />
        </svg>
      }
      @default {
        <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16">
          <path
            d="M4 2.5A1.5 1.5 0 0 1 5.5 1h5A1.5 1.5 0 0 1 12 2.5V3h1.5A1.5 1.5 0 0 1 15 4.5v10a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-10A1.5 1.5 0 0 1 2.5 3H4v-.5zM5 3h2V2H5.5a.5.5 0 0 0-.5.5V3zm3 0h3v-.5a.5.5 0 0 0-.5-.5H8v1zM2 4.5V14h12V4.5a.5.5 0 0 0-.5-.5H12v1.5a.5.5 0 0 1-1 0V4H5v1.5a.5.5 0 0 1-1 0V4H2.5a.5.5 0 0 0-.5.5z"
          />
        </svg>
      }
    }
  </span>
</ng-template>
